import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/NavigationCard.scss';

// Import SVG icons
import IconCard1 from '../assets/icon_card_1.svg';
import IconCard2 from '../assets/icon_card_2.svg';
import IconCard3 from '../assets/icon_card_3.svg';
import IconCard4 from '../assets/icon_card_4.svg';
import IconCard5 from '../assets/icon_card_5.svg';

interface NavigationCardProps {
  title: string;
  description: string;
  linkTo: string;
  iconName: 'onboarding' | 'tests' | 'big-five' | 'thermometer' | 'counseling';
  cardColor: 'dark' | 'light' | 'white';
  className?: string; // For grid-area targeting
}

const NavigationCard: React.FC<NavigationCardProps> = ({
  title,
  description,
  linkTo,
  iconName,
  cardColor,
  className,
}) => {
  const getIcon = () => {
    switch (iconName) {
      case 'onboarding':
        return <img src={IconCard5} alt={title} />;
      case 'tests':
        return <img src={IconCard2} alt={title} />;
      case 'big-five':
        return <img src={IconCard4} alt={title} />;
      case 'thermometer':
        return <img src={IconCard1} alt={title} />;
      case 'counseling':
        return <img src={IconCard3} alt={title} />;
      default:
        return null;
    }
  };

  const cardClassName = `navigation-card ${cardColor} ${className || ''}`;

  return (
    <Link to={linkTo} className={cardClassName}>
      <div className="navigation-card__icon">{getIcon()}</div>
      <div className="navigation-card__content">
        <h4 className="navigation-card__title">{title}</h4>
        <p className="navigation-card__description">{description}</p>
      </div>
    </Link>
  );
};

export default NavigationCard;
